const UserActionType = {
    USER_LOGIN_REQUEST : 'USER_LOGIN_REQUEST',
    USER_LOGIN_SUCCESS : 'USER_LOGIN_SUCCESS',
    USER_LOGIN_FAIL : 'USER_LOGIN_FAIL',
    
    USER_LOGOUT : 'USER_LOGOUT',

    USER_REGISTER_REQUEST : 'USER_REGISTER_REQUEST',
    USER_REGISTER_SUCCESS : 'USER_REGISTER_SUCCESS',
    USER_REGISTER_FAIL : 'USER_REGISTER_FAIL',



    USER_PROFILE_REQUEST : 'USER_PROFILE_REQUEST',
    USER_PROFILE_SUCCESS : 'USER_PROFILE_SUCCESS',
    USER_PROFILE_FAIL : 'USER_PROFILE_FAIL',


    USER_ADDRESS_REQUEST : 'USER_ADDRESS_REQUEST',
    USER_ADDRESS_SUCCESS : 'USER_ADDRESS_SUCCESS',
    USER_ADDRESS_FAIL : 'USER_ADDRESS_FAIL',



    
}

export default UserActionType